import clsx from 'clsx'
import React from 'react'
import Button from '../../../../atoms/Button'
import Answer from './AnswerSection'
import useStyles from './styles'

const QuestionSection = ({
  question,
  idx,
  handleAdd,
  handleQuestionChange,
  handleMoveAnswer,
  handleRemoveAnswer,
  inboxes,
  handleAnswerInboxAdd,
  handleMoveAnswerInbox,
  handleRemoveAnswerInbox,
  newAnserRef
}) => {
  const classes = useStyles()

  return (
    <React.Fragment>
      <div className={clsx(classes.newQuestion, classes.marginBottom)}>
        <input
          placeholder='Question/Title'
          defaultValue={question.title}
          onBlur={e => {
            handleQuestionChange(idx, 'title', e.target.value)
          }}
        />
      </div>

      <div className={classes.answerSection}>
        {Array.isArray(question?.options) &&
          question?.options.map((item, answerIdx) => {
            return (
              <Answer
                id={item.value}
                key={item.value}
                index={answerIdx}
                item={item}
                questionIndex={idx}
                handleMoveAnswer={handleMoveAnswer}
                handleRemoveAnswer={handleRemoveAnswer}
                inboxes={inboxes}
                handleAnswerInboxAdd={handleAnswerInboxAdd}
                handleMoveAnswerInbox={handleMoveAnswerInbox}
                handleRemoveAnswerInbox={handleRemoveAnswerInbox}
              />
            )
          })}
      </div>

      <div className={classes.newAnswer}>
        <input
          ref={newAnserRef}
          placeholder='New answer'
          onKeyDown={e => e.key === 'Enter' && handleAdd(idx)}
        />

        <Button onClick={() => handleAdd(idx)} className='button'>
          ADD
        </Button>
      </div>
    </React.Fragment>
  )
}

export default QuestionSection
